import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61744658"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mb-2 ms-2",
  style: {"color":"#ff8800","font-size":"18px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-triangle-exclamation fa-lg me-1",
  style: {"color":"#ff8800"}
}, null, -1))
const _hoisted_3 = { class: "input-group mb-3" }
const _hoisted_4 = {
  class: "input-group-text",
  for: "inputGroupSelect01"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-4 text-end",
  style: {"color":"#d9534f"}
}, [
  /*#__PURE__*/_createTextVNode(" 如要新增 "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "貨幣"),
  /*#__PURE__*/_createTextVNode(" 請通知 IT Department ")
], -1))
const _hoisted_14 = { class: "d-flex justify-content-end gap-2 my-3" }
const _hoisted_15 = { class: "d-flex gap-2 mb-3" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-header p-4" }
const _hoisted_19 = { class: "d-flex align-items-end" }
const _hoisted_20 = {
  class: "fs-1 fw-bold",
  style: {"color":"#5cb85c"}
}
const _hoisted_21 = {
  class: "fs-4 ms-3 pb-1 fw-bold",
  style: {"color":"#6c757d"}
}
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fw-bold" }, "Deposit 卖出价", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fw-bold" }, "Withdraw 买入价", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fw-bold" }, "Adjust 调整 %", -1))
const _hoisted_27 = { class: "fw-bold text-center" }
const _hoisted_28 = { class: "fw-bold text-center" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { key: 3 }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { style: {"font-size":"12px","color":"rgba(113, 113, 113, 1)"} }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "mb-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted mb-3" }, [
  /*#__PURE__*/_createTextVNode(" Upload a CSV or XLSX file with columns: "),
  /*#__PURE__*/_createElementVNode("strong", null, "name, I, O, Adjust")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" Drop CSV/XLSX here or "),
  /*#__PURE__*/_createElementVNode("em", null, "click to browse")
], -1))
const _hoisted_39 = {
  key: 0,
  class: "mt-5"
}

import moment from "moment";

import { ref, onMounted } from "vue";
import type { UploadProps, UploadUserFile } from "element-plus";
import { Download, UploadFilled } from "@element-plus/icons-vue";
import LoadingRing from "@/components/LoadingRing.vue";
import PaymentService from "../services/PaymentService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import NoDataBox from "@/components/NoDataBox.vue";
import { useI18n } from "vue-i18n";

type BulkUploadRowResult = {
  row: number;
  name: string;
  success: boolean;
  id: number | null;
  reason: string;
};

type BulkUploadResult = {
  total: number;
  updated: number;
  failed: number;
  results: BulkUploadRowResult[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeRate',
  setup(__props) {

const t = useI18n().t;
const isSubmitting = ref(false);
const selectedCurrency = ref("");
const newData = ref({} as any);
const fromCurrencies = ref<any>([]);
const exchangeRates = ref([] as any);
const rateSymbols = ref({} as any);
const bulkUploadVisible = ref(false);
const isBulkUploading = ref(false);
const hasBulkUploadSubmitted = ref(false);
const selectedBulkFile = ref<File | null>(null);
const bulkUploadFileList = ref<UploadUserFile[]>([]);
const bulkUploadRef = ref<any>(null);
const bulkUploadResult = ref<BulkUploadResult | null>(null);
const criteria = ref({
  size: 5,
});

const getFromCurrencies = async (data) => {
  try {
    fromCurrencies.value = data.map((item) => {
      return {
        fromCurrencyId: item.fromCurrencyId,
        fromCurrencyCode: item.fromCurrencyCode,
      };
    });
    // Remove duplicates
    fromCurrencies.value = Array.from(
      new Set(fromCurrencies.value.map((item) => item.fromCurrencyCode))
    ).map((code) => {
      return fromCurrencies.value.find(
        (item) => item.fromCurrencyCode === code
      );
    });
    console.log(fromCurrencies.value);
  } catch (error) {
    console.error("Error fetching from currencies:", error);
  }
};

const fetchData = async (_currency?: any) => {
  var currency = _currency || null;

  if (currency) {
    currency = currency.fromCurrencyId || currency;
  }
  selectedCurrency.value = currency || "";
  rateSymbols.value = {};
  const res = await PaymentService.getExchangeRate({
    page: 1,
    size: 100,
    numPages: 1,
    fromCurrencyId: currency,
  });

  exchangeRates.value = res.data;
  res.data.forEach((item) => {
    if (rateSymbols.value[item.name] == undefined)
      rateSymbols.value[item.name] = {};
    rateSymbols.value[item.name].id = item.id;
    rateSymbols.value[item.name].symbol = item.name;
    rateSymbols.value[item.name].from = item.fromCurrencyId;
    rateSymbols.value[item.name].to = item.toCurrencyId;
    rateSymbols.value[item.name].isLoading = true;
    rateSymbols.value[item.name].error = "";
    rateSymbols.value[item.name].data = [];
  });
  for (const key of Object.keys(rateSymbols.value)) {
    getRate(rateSymbols.value[key]);
  }
};

onMounted(async () => {
  await fetchData();
  await getFromCurrencies(exchangeRates.value);
});

const getRate = async (item: any) => {
  item.isLoading = true;
  item.data = [];

  try {
    var data = [] as any;

    data = await PaymentService.getExchangeRateHistory(item.id, criteria.value);
    const dataLength = ref(
      criteria.value.size < data.length ? criteria.value.size : data.length
    );
    console.log(data[0]);
    if (data.length == 0) {
      item.isLoading = false;
    } else {
      for (let i = 0; i < dataLength.value; i++) {
        item.data.push({
          deposit: data[i]?.changes.currentValues.SellingRate ?? "--",
          markupDeposit:
            data[i]?.id == 2
              ? Math.ceil(
                  data[i]?.changes.currentValues.SellingRate *
                    (1 + data[i]?.changes.currentValues.AdjustRate / 100) *
                    1000
                ) / 1000
              : Math.ceil(
                  data[i]?.changes.currentValues.SellingRate *
                    (1 + data[i]?.changes.currentValues.AdjustRate / 100) *
                    100000
                ) / 100000,
          withdraw: data[i]?.changes.currentValues.BuyingRate ?? "--",
          markupWithdraw:
            data[i]?.id == 2
              ? Math.floor(
                  data[i]?.changes.currentValues.BuyingRate *
                    (1 - data[i]?.changes.currentValues.AdjustRate / 100) *
                    1000
                ) / 1000
              : Math.floor(
                  data[i]?.changes.currentValues.BuyingRate *
                    (1 - data[i]?.changes.currentValues.AdjustRate / 100) *
                    100000
                ) / 100000,
          adjust: data[i]?.changes.currentValues.AdjustRate,

          updatedOn: data[i]?.createdOn,
          staff: data[i]?.operatorName,
        });
      }
    }
  } catch (error) {
    item.error = error;
  }
  item.isLoading = false;
};

const openBulkUpload = () => {
  bulkUploadResult.value = null;
  hasBulkUploadSubmitted.value = false;
  selectedBulkFile.value = null;
  bulkUploadFileList.value = [];
  bulkUploadRef.value?.clearFiles();
  bulkUploadVisible.value = true;
};

const isAllowedBulkUploadFile = (file: File) => {
  const fileName = file.name.toLowerCase();
  return fileName.endsWith(".csv") || fileName.endsWith(".xlsx");
};

const handleBulkFileChange: UploadProps["onChange"] = (file) => {
  if (!file.raw || !isAllowedBulkUploadFile(file.raw)) {
    selectedBulkFile.value = null;
    bulkUploadFileList.value = [];
    bulkUploadRef.value?.clearFiles();
    MsgPrompt.error("Only .csv and .xlsx files are supported.");
    return;
  }

  selectedBulkFile.value = file.raw;
  bulkUploadResult.value = null;
  hasBulkUploadSubmitted.value = false;
};

const handleBulkFileRemove = () => {
  selectedBulkFile.value = null;
};

const submitBulkUpload = async () => {
  if (
    !selectedBulkFile.value ||
    isBulkUploading.value ||
    hasBulkUploadSubmitted.value
  )
    return;

  hasBulkUploadSubmitted.value = true;
  isBulkUploading.value = true;
  try {
    const formData = new FormData();
    formData.append("file", selectedBulkFile.value);
    bulkUploadResult.value = await PaymentService.bulkUploadExchangeRate(
      formData
    );
    await fetchData(selectedCurrency.value || undefined);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isBulkUploading.value = false;
  }
};

const getBulkResultRowClass = ({ row }: { row: BulkUploadRowResult }) => {
  return row.success ? "" : "bulk-upload-failed-row";
};

const downloadBulkUploadTemplate = () => {
  const csvContent = "name,I,O,Adjust\nUSDJPY,150.1,150.2,0\n";
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = "exchange-rate-bulk-upload-template.csv";
  link.click();
  URL.revokeObjectURL(url);
};

const create = async () => {
  if (
    Object.keys(newData.value).length == 0 ||
    newData.value.symbol == "" ||
    newData.value.symbol == undefined
  ) {
    return;
  }

  const sellingRate = ref(newData.value.deposit);
  const buyingRate = ref(newData.value.withdraw);

  if (sellingRate.value == undefined || sellingRate.value == 0) {
    sellingRate.value =
      rateSymbols.value[newData.value.symbol].data[0]?.deposit ?? 0;
  }
  if (buyingRate.value == undefined || buyingRate.value == 0) {
    buyingRate.value =
      rateSymbols.value[newData.value.symbol].data[0]?.withdraw ?? 0;
  }

  isSubmitting.value = true;

  try {
    await PaymentService.putExchangeRate(
      rateSymbols.value[newData.value.symbol].id,
      {
        id: rateSymbols.value[newData.value.symbol].id,
        name: rateSymbols.value[newData.value.symbol].symbol,
        sellingRate: sellingRate.value,
        buyingRate: buyingRate.value,
        adjustRate: newData.value.adjust == "" ? 0 : newData.value.adjust,
      }
    );

    isSubmitting.value = false;

    MsgPrompt.success("Exchange Rate Update Success").then(() => {
      getRate(rateSymbols.value[newData.value.symbol]);
    });
  } catch (error) {
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("tip.rateUpdate")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("action.createNewRate")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control",
        name: "depositRate",
        placeholder: _unref(t)('fields.depositRate'),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newData.value.deposit) = $event))
      }, null, 8, _hoisted_5), [
        [_vModelText, newData.value.deposit]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control",
        name: "depositRate",
        placeholder: _unref(t)('fields.withdrawalRate'),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newData.value.withdraw) = $event))
      }, null, 8, _hoisted_6), [
        [_vModelText, newData.value.withdraw]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control",
        name: "adjujstRate",
        placeholder: _unref(t)('fields.markup'),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newData.value.adjust) = $event))
      }, null, 8, _hoisted_7), [
        [_vModelText, newData.value.adjust]
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-select",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newData.value.symbol) = $event))
      }, [
        _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("action.selectSymbols")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rateSymbols.value, (item, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: index,
            value: item.symbol
          }, _toDisplayString(item.symbol), 9, _hoisted_9))
        }), 128))
      ], 512), [
        [_vModelSelect, newData.value.symbol]
      ]),
      _createElementVNode("button", {
        class: "btn btn-secondary",
        type: "button",
        onClick: create
      }, [
        (isSubmitting.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
              _hoisted_11
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("action.create")), 1))
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_el_button, {
        icon: _unref(Download),
        onClick: downloadBulkUploadTemplate
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Download Template ")
        ]),
        _: 1
      }, 8, ["icon"]),
      _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(UploadFilled),
        onClick: openBulkUpload
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Bulk Upload ")
        ]),
        _: 1
      }, 8, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_el_button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (fetchData())),
        type: selectedCurrency.value === '' ? 'warning' : 'default'
      }, {
        default: _withCtx(() => [
          _createTextVNode("All")
        ]),
        _: 1
      }, 8, ["type"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fromCurrencies.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_button, {
          key: item,
          onClick: ($event: any) => (fetchData(item)),
          type: selectedCurrency.value === item.fromCurrencyId ? 'warning' : 'default'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.fromCurrencyCode), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "type"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rateSymbols.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-6 mb-4",
          key: index
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(item.symbol), 1),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("title.exchangeRate")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("table", _hoisted_23, [
                _createElementVNode("thead", null, [
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t("fields.operator")), 1)
                ]),
                (item.isLoading)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_29, [
                      _createVNode(LoadingRing)
                    ]))
                  : (!item.isLoading && item.data.length === 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                        _createVNode(NoDataBox)
                      ]))
                    : (item.error)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_31, _toDisplayString(item.error), 1))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (rate, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(rate.markupDeposit) + " (" + _toDisplayString(rate.deposit) + ")", 1),
                              _createElementVNode("td", null, _toDisplayString(rate.markupWithdraw) + " (" + _toDisplayString(rate.withdraw) + ")", 1),
                              _createElementVNode("td", null, _toDisplayString(rate.adjust), 1),
                              _createElementVNode("td", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(moment)(rate.updatedOn).format("M-D H:m:s")), 1)
                              ]),
                              _createElementVNode("td", _hoisted_35, _toDisplayString(rate.staff), 1)
                            ]))
                          }), 128))
                        ]))
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: bulkUploadVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((bulkUploadVisible).value = $event)),
      title: "Bulk Upload Exchange Rate",
      width: "760px",
      "align-center": "",
      "close-on-click-modal": !isBulkUploading.value,
      "close-on-press-escape": !isBulkUploading.value
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          disabled: isBulkUploading.value,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (bulkUploadVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(bulkUploadResult.value ? _ctx.$t("action.close") : _ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: isBulkUploading.value,
          disabled: !selectedBulkFile.value || hasBulkUploadSubmitted.value,
          onClick: submitBulkUpload
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Upload ")
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode(_component_el_upload, {
            ref_key: "bulkUploadRef",
            ref: bulkUploadRef,
            "file-list": bulkUploadFileList.value,
            "onUpdate:fileList": _cache[5] || (_cache[5] = ($event: any) => ((bulkUploadFileList).value = $event)),
            "auto-upload": false,
            disabled: isBulkUploading.value || hasBulkUploadSubmitted.value,
            limit: 1,
            "on-change": handleBulkFileChange,
            "on-remove": handleBulkFileRemove,
            accept: ".csv,.xlsx",
            drag: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UploadFilled))
                ]),
                _: 1
              }),
              _hoisted_38
            ]),
            _: 1
          }, 8, ["file-list", "disabled"])
        ]),
        (bulkUploadResult.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createVNode(_component_el_descriptions, {
                column: 3,
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "Total" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(bulkUploadResult.value.total), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Updated" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(bulkUploadResult.value.updated), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Failed" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'text-danger fw-bold': bulkUploadResult.value.failed > 0 })
                      }, _toDisplayString(bulkUploadResult.value.failed), 3)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_table, {
                class: "mt-4",
                data: bulkUploadResult.value.results,
                "row-class-name": getBulkResultRowClass,
                "max-height": "360",
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "row",
                    label: "Row",
                    width: "90"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Name",
                    "min-width": "140"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Status",
                    width: "120"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_tag, {
                        type: row.success ? 'success' : 'danger'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.success ? "Success" : "Failed"), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "reason",
                    label: "Reason",
                    "min-width": "240"
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "close-on-click-modal", "close-on-press-escape"])
  ], 64))
}
}

})